import {Component, OnInit, ViewChild} from '@angular/core';
import {StateService} from '@uirouter/angular';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  collapse: boolean = true;

  closeResult: any;
  activeTab = 'login';
  user_error = '';
  password_error = '';
  loginForm = {
    // "username": "",
    // "password": ""
  };
  signForm = {};
  modalRef: NgbModalRef;


  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService
  ) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/header/header.component.ts